import{_}from"./_nativeCreate.js";var a=_;var s=function(_,s){var t=this.__data__;return this.size+=this.has(_)?0:1,t[_]=a&&void 0===s?"__lodash_hash_undefined__":s,this};export{s as _};
